import '@clr/core/checkbox/register';
import { wrapCustomElement } from '../../utils';
/**
 * Clarity Core's `cds-checkbox` wrapper.
 */
export const CoreCheckbox = wrapCustomElement('cds-checkbox');
export default CoreCheckbox;
